export default {
  getSalesOrderLine: (state) => state.salesOrderLine,
};
